import { createContext, useContext } from 'react';

/**
 * Context providing overlay state to its children.
 */ const OverlayContext = /*#__PURE__*/ createContext(null);
/**
 * Provider for {@link OverlayContext}.
 */ const OverlayProvider = OverlayContext.Provider;
/**
 * Hook to access the {@link OverlayContext} value.
 */ const useOverlayContext = ()=>useContext(OverlayContext);

export { OverlayContext, OverlayProvider, useOverlayContext };
//# sourceMappingURL=overlay-context.js.map
